/* eslint-disable */
import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { RegularButton, CommonInput } from 'pg-ui-library';
import closeSvg from 'src/assets/close.svg';
import { Header, FormTitle, CloseIcon } from './filtersStyles';

import { ModalContainer, Subtitle } from './downloadModalStyles';

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onBatchDownload: (batchCode: string) => void;
  loading?: boolean;
}

const BatchDownloadModal: React.FC<Props> = ({ isOpen, setIsOpen, onBatchDownload, loading }) => {
  const [batchCode, setBatchCode] = useState('');

  const handleClose = () => {
    setBatchCode('');
    setIsOpen(false);
  };

  const handleSubmit = () => {
    if (batchCode.trim()) {
      onBatchDownload(batchCode.trim());
    }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={handleClose}
      ariaHideApp={false}
      style={{
        overlay: { backgroundColor: 'rgba(0, 0, 0, 0.6)' },
        content: {
          borderRadius: '20px',
          backgroundColor: '#F3F4F8',
          margin: 'auto',
          width: '400px',
          height: '350px',
          padding: '20px',
        },
      }}
    >
      <ModalContainer>
        <Header>
          <FormTitle>Batch Download</FormTitle>
          <CloseIcon src={closeSvg} onClick={handleClose} />
        </Header>

        <Subtitle>Enter your batch code to start downloading</Subtitle>

        <div style={{ margin: '20px 0' }}>
          <CommonInput
            label=""
            placeholder="Enter batch code"
            value={batchCode}
            onChange={(e: any) => setBatchCode(e.target.value)}
          />
        </div>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '30px' }}>
          <RegularButton onClick={handleClose} disabled={loading}>
            Cancel
          </RegularButton>

          <RegularButton onClick={handleSubmit} disabled={!batchCode.trim() || loading}>
            {loading ? 'Downloading...' : 'Download'}
          </RegularButton>
        </div>
      </ModalContainer>
    </ReactModal>
  );
};

export default BatchDownloadModal;
